export default {
  imageInOriginalSize: 'Bild in Originalgröße: {{alt}}',
  imageIsLoading: 'Bild wird geladen',
  alternativeText: {
    portalAvatar: 'Avatarlogo für das Portal',
    portalLogo: 'Logo für das Portal',
    defaultImage: 'Vorschaubild (noch kein Bild hochgeladen)',
    contentImage: 'Platzhalter-Inhaltsbild (noch kein Bild hochgeladen)',
    profileImage: 'Platzhalter-Profilbild (noch kein Bild hochgeladen)',
    profileImageSmall: 'Platzhalter-Profilbild (noch kein Bild hochgeladen)',
    teaserImage: 'Platzhalter-Teaserbild (noch kein Bild hochgeladen)',
    titleImage: 'Platzhalter-Titelbild (noch kein Bild hochgeladen)',
  },
} as const;
